import { useEffect } from "react";
import { CustomerActivityData, CustomerActivityDelete } from "../types";
import { Column, Row } from "../../../containers";
import { AlignItems, JustifyContent, Wrap } from "../../../containers/types";
import { TextInput } from "../../../inputs";
import { Tags } from "../../../tag";
import { Heading } from "../../../typography";
import { usePopupStore, useThemeStore } from "../../../../stores";
import { PopupBack, PopupClose } from "../../../../popup";
import { BackContainer } from "../../../../types";

const CustomerDeleteActivityPopup = <T extends {}>(
  props: BackContainer<CustomerActivityData, T>
) => {
  const activity = props.data as CustomerActivityDelete;
  const theme = useThemeStore((state) => state.theme);
  const popupProperties = usePopupStore((s) => s.popupProperties);
  const setPopupProperties = usePopupStore((s) => s.setPopupProperties);

  useEffect(() => {
    setPopupProperties({
      ...popupProperties,
      style: {
        ...popupProperties.style,
        maxHeight: "80%",
        overflowY: "auto",
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  return (
    <Column
      alignItems={AlignItems.Center}
      justifyContent={JustifyContent.Start}
      style={{ marginBottom: "1rem", position: "relative" }}
      gap={20}
    >
      <PopupClose />

      {props.back ? (
        <PopupBack Component={props.back.component} props={props.back.props} />
      ) : (
        <></>
      )}

      <Heading
        textStyles={{ marginTop: "1rem" }}
        size={19}
        color={theme.textOnOverlay}
      >
        حذف مشتری
      </Heading>
      <Row
        style={{ width: "90%" }}
        justifyContent={JustifyContent.Between}
        gap={20}
        flexWrap={Wrap.Wrap}
        className="customer-activity-popup-row"
      >
        <TextInput
          style={{ maxWidth: 300 }}
          label="نام و نام خانوادگی"
          value={activity.fullname}
          inputProps={{ readOnly: true }}
        />
        <TextInput
          style={{ maxWidth: 300 }}
          label="کد ملی"
          value={activity.national_code}
          inputProps={{ readOnly: true }}
        />
      </Row>
      <Row
        style={{ width: "90%" }}
        justifyContent={JustifyContent.Between}
        gap={20}
        flexWrap={Wrap.Wrap}
        className="customer-activity-popup-row"
      >
        <TextInput
          style={{ maxWidth: 300 }}
          label="تلفن همراه"
          value={activity.phone}
          inputProps={{ readOnly: true }}
        />
        <TextInput
          style={{ maxWidth: 300 }}
          label="آدرس"
          value={activity.address}
          inputProps={{ readOnly: true }}
        />
      </Row>
      <Row
        style={{ width: "90%" }}
        justifyContent={JustifyContent.Between}
        gap={20}
        flexWrap={Wrap.Wrap}
      >
        <Tags>{activity.tags}</Tags>
      </Row>
    </Column>
  );
};

export default CustomerDeleteActivityPopup;
